<template>
  <div class="dashboard body">
    <el-container>
      <!-- <Aside @toggle="toggle($event)" /> -->
      <el-main>
        <button
          v-show="1 == 0"
          v-shortkey="['f3']"
          @shortkey="showHiden = !showHiden"
        ></button>
        <button
          v-show="1 == 0"
          v-shortkey="['f10']"
          @shortkey="confirmSave = true"
        ></button>
        <button
          v-show="1 == 0"
          v-shortkey="['f9']"
          @shortkey="saveShortKey"
        ></button>
        <div style="margin-top: -11px">
          <el-button
            plain
            @click="setSelectedInvoice(index)"
            style="margin-right: 5px"
            v-for="(invoice, index) in sales"
            :key="index"
            :type="selectedIndex == index ? 'warning' : 'success'"
          >
            {{ index + 1 }}
          </el-button>
          <el-button
            plain
            type="primary"
            style="margin-right: 5px"
            @click="addNewInvoice"
          >
            <i class="fas fa-plus"></i>
          </el-button>
        </div>
        <el-row :gutter="10">
          <el-col :xl="24" :lg="24" :md="24" :sm="24">
            <SearchCustomers
              ref="searchCustomersComponent"
              :customer="sales[selectedIndex].customer"
              @selectedCustomer="selectedCustomer"
              :productSearch="false"
              :searchOnly="false"
              :showLabel="true"
              :productsLength="sales[selectedIndex].products.length"
              :useParcode="useParcode"
            />
          </el-col>
          <!-- <el-col :xl="6" :lg="6" :md="24" :sm="24" class="mt-2">
            <SearchProductsWithBarcode
              @selectedProductWithBarcode="selectedProductWithBarcode"
              :customer="sales[selectedIndex].customer"
              ref="searchProductsWithBarcode"
            >
              <template #useParcode>
                <el-checkbox
                  class="mr-2"
                  label="بحث الباركود"
                  v-model="useParcode"
                  @change="useBarcode"
                ></el-checkbox>
              </template>
              <template #autoPush>
                <el-switch
                  v-model="autoPush"
                  active-text="اضافة تلقائي"
                ></el-switch>
              </template>
            </SearchProductsWithBarcode>
          </el-col> -->
        </el-row>

        <div class="sales-info">
          <div class="row">
            <div class="col-md-6">
              <div
                class="sales-info-container"
                v-if="sales[selectedIndex].products.length > 0"
              >
                <div class="info-card">
                  <h6>الكميه</h6>
                  <span class="num">{{ sales[selectedIndex].total_qty }}</span>
                </div>

                <div
                  class="info-card"
                  v-if="sales[selectedIndex].products.length > 0"
                >
                  <h6>الفاتوره</h6>
                  <span>{{
                    numberToFixed(sales[selectedIndex].total_sale_cost)
                  }}</span>
                </div>

                <div
                  class="info-card"
                  v-if="sales[selectedIndex].total_discount > 0"
                >
                  <h6>بعد الخصم</h6>
                  <span>{{
                    numberToFixed(
                      sales[selectedIndex].total_sale_cost -
                        sales[selectedIndex].total_discount
                    )
                  }}</span>
                </div>

                <div class="info-card" v-if="showHiden">
                  <h6>الربح</h6>
                  <span>{{
                    numberToFixed(
                      sales[selectedIndex].total_sale_cost -
                        sales[selectedIndex].total_discount -
                        sales[selectedIndex].total_buy_cost
                    )
                  }}</span>
                </div>

                <div v-show="sales[selectedIndex].products.length > 0">
                  <el-button
                    class="save babyblue-btn"
                    :loading="isLoading"
                    @click="showPaymentModal"
                    >حفظ الفاتوره</el-button
                  >
                </div>

                <div>
                  <span
                    :class="[
                      sales[selectedIndex].products.length > 0 ? '' : 'mr-auto',
                    ]"
                  >
                    <el-popconfirm
                      confirm-button-text="موافق"
                      cancel-button-text="إلغاء"
                      icon="el-icon-info"
                      icon-color="red"
                      title="هل تريد مسح الفاتورة؟"
                      @confirm="resetInvoiceData"
                    >
                      <div slot="reference">
                        <el-button class="pink-btn exit"
                          >مسح الفاتورة</el-button
                        >
                      </div>
                    </el-popconfirm></span
                  >
                </div>
              </div>
            </div>

            <div class="col-md-6"></div>
          </div>
        </div>

        <el-row class="table mt-2 px-3">
          <div
            class="
              el-table
              el-table--fit
              el-table--border
              el-table--scrollable-y
              el-table--enable-row-hover
              el-table--enable-row-transition
            "
            style="margin-top: 20px; height: 58vh"
          >
            <div class="el-table__header-wrapper">
              <table
                cellspacing="0"
                cellpadding="0"
                border="0"
                class="el-table__header"
                style="width: 100%"
              >
                <colgroup>
                  <col name="el-table_3_column_11" width="4%" />
                  <col name="el-table_3_column_12" width="32%" />
                  <col name="el-table_3_column_13" width="10%" />
                  <col name="el-table_3_column_14" width="10%" />
                  <col name="el-table_3_column_15" width="10%" />
                  <col name="el-table_3_column_16" width="8%" />
                  <col name="el-table_3_column_17" width="8%" />
                  <col
                    name="el-table_3_column_18"
                    v-if="showHiden"
                    width="8%"
                  />
                  <col
                    name="el-table_3_column_19"
                    v-if="showHiden"
                    width="8%"
                  />
                  <col name="el-table_3_column_20" width="7%" />
                  <col name="el-table_3_column_21" width="5%" />
                </colgroup>
                <thead class="has-gutter">
                  <tr class="">
                    <th
                      colspan="1"
                      rowspan="1"
                      class="el-table_3_column_11 is-leaf"
                    >
                      <div class="cell">#</div>
                    </th>
                    <th
                      colspan="1"
                      rowspan="1"
                      class="el-table_3_column_12 is-leaf"
                    >
                      <div class="cell">المنتج</div>
                    </th>
                    <th
                      colspan="1"
                      rowspan="1"
                      class="el-table_3_column_13 is-leaf"
                    >
                      <div class="cell">الوحدة</div>
                    </th>
                    <th
                      colspan="1"
                      rowspan="1"
                      class="el-table_3_column_14 is-leaf"
                    >
                      <div class="cell">الكمية</div>
                    </th>
                    <th
                      colspan="1"
                      rowspan="1"
                      class="el-table_3_column_15 is-leaf"
                    >
                      <div class="cell">سعر البيع</div>
                    </th>
                    <th
                      colspan="1"
                      rowspan="1"
                      class="el-table_3_column_16 is-leaf"
                    >
                      <div class="cell center">أخر سعر</div>
                    </th>
                    <th
                      colspan="1"
                      rowspan="1"
                      class="el-table_3_column_17 is-leaf"
                    >
                      <div class="cell center">الإجمالي</div>
                    </th>
                    <th
                      v-if="showHiden"
                      colspan="1"
                      rowspan="1"
                      class="el-table_3_column_18 is-leaf"
                    >
                      <div class="cell center">سعر الشراء</div>
                    </th>
                    <th
                      v-if="showHiden"
                      colspan="1"
                      rowspan="1"
                      class="el-table_3_column_19 is-leaf"
                    >
                      <div class="cell center">الربح</div>
                    </th>
                    <th
                      colspan="1"
                      rowspan="1"
                      class="el-table_3_column_20 is-leaf"
                    >
                      <div class="cell center">المتاح</div>
                    </th>
                    <th
                      colspan="1"
                      rowspan="1"
                      class="el-table_3_column_21 is-leaf"
                    >
                      <div class="cell"></div>
                    </th>
                  </tr>
                </thead>
              </table>
            </div>
            <!-- id="scrollToMe" -->
            <div
              class="el-table__body-wrapper"
              style="height: auto; max-height: 44vh"
              ref="products_table"
            >
              <table
                cellspacing="0"
                cellpadding="0"
                border="0"
                class="el-table__body"
                style="width: 100%"
              >
                <colgroup>
                  <col name="el-table_3_column_11" width="4%" />
                  <col name="el-table_3_column_12" width="32%" />
                  <col name="el-table_3_column_13" width="10%" />
                  <col name="el-table_3_column_14" width="10%" />
                  <col name="el-table_3_column_15" width="10%" />
                  <col name="el-table_3_column_16" width="8%" />
                  <col name="el-table_3_column_17" width="8%" />
                  <col
                    name="el-table_3_column_18"
                    v-if="showHiden"
                    width="8%"
                  />
                  <col
                    name="el-table_3_column_19"
                    v-if="showHiden"
                    width="8%"
                  />
                  <col name="el-table_3_column_20" width="7%" />
                  <col name="el-table_3_column_21" width="5%" />
                </colgroup>
                <!-- id="order" -->
                <tbody class="bodytable">
                  <tr
                    class="el-table__row"
                    v-for="(item, index) in sales[selectedIndex].products"
                    :key="index"
                  >
                    <!-- :class="[
                      item.sale_price < 5 || item.qty < 5 ? 'bg-Red' : '',
                    ]" -->
                    <td rowspan="1" colspan="1" class="el-table_3_column_11">
                      <div class="cell num">{{ index + 1 }}</div>
                    </td>
                    <td rowspan="1" colspan="1" class="el-table_3_column_12">
                      <div class="cell">{{ item.name }}</div>
                    </td>
                    <td rowspan="1" colspan="1" class="el-table_3_column_13">
                      <div class="cell">
                        {{ item.unit.unit }}
                        <!-- <el-select
                          v-model="form.selected"
                          placeholder="حدد الوحدة"
                        >
                          <el-option
                            v-for="item in options"
                            :key="item.value"
                            :label="item.label"
                            :value="item.value"
                          >
                          </el-option>
                        </el-select> -->
                      </div>
                    </td>
                    <td rowspan="1" colspan="1" class="el-table_3_column_14">
                      <div class="cell">
                        <!-- New -->
                        <!-- readonly -->
                        <input
                          @blur="updateProductQty(item, index)"
                          class="form-control"
                          type="number"
                          @change="calcTotal"
                          @focus="$event.target.select()"
                          v-model="item.qty"
                          placeholder="الكمية"
                          min="0"
                        />
                      </div>
                    </td>
                    <td rowspan="1" colspan="1" class="el-table_3_column_15">
                      <div class="cell">
                        <input
                          class="form-control"
                          type="number"
                          @change="calcTotal"
                          @focus="$event.target.select()"
                          v-model="item.sale_price"
                          placeholder=" البيع"
                          min="0"
                        />
                      </div>
                    </td>
                    <td rowspan="1" colspan="1" class="el-table_3_column_16">
                      <div class="cell center">
                        {{ numberToFixed(item.lastSaleCost) }}
                      </div>
                    </td>
                    <td rowspan="1" colspan="1" class="el-table_3_column_17">
                      <div class="cell center">
                        {{ numberToFixed(item.sale_price * item.qty) }}
                      </div>
                    </td>
                    <td
                      rowspan="1"
                      colspan="1"
                      class="el-table_3_column_18"
                      v-if="showHiden"
                    >
                      <div class="cell center">
                        {{ numberToFixed(item.buy_cost) }}
                      </div>
                    </td>
                    <td
                      rowspan="1"
                      colspan="1"
                      class="el-table_3_column_19"
                      v-if="showHiden"
                    >
                      <div class="cell center">
                        {{ numberToFixed(item.sale_price - item.buy_cost) }}
                      </div>
                    </td>
                    <td rowspan="1" colspan="1" class="el-table_3_column_20">
                      <div class="cell center">
                        {{ numberToFixed(item.stock) }}
                      </div>
                    </td>
                    <td rowspan="1" colspan="1" class="el-table_3_column_21">
                      <div class="cell">
                        <el-popconfirm
                          confirm-button-text="موافق"
                          cancel-button-text="إلغاء"
                          icon="el-icon-info"
                          icon-color="red"
                          :title="'هل تريد حذف ' + ' ' + item.name + ' ؟'"
                          @confirm="deleteItem(item, index)"
                        >
                          <div slot="reference" class="deleteicon">
                            <i class="fas fa-trash-alt"></i>
                          </div>
                        </el-popconfirm>
                      </div>
                    </td>
                  </tr>
                </tbody>
              </table>

              <a id="goToBottom" href="#scrollToMe"></a>
              <div id="scrollToMe"></div>
            </div>
            <div
              class="el-table__footer-wrapper"
              v-if="sales[selectedIndex].customer"
            >
              <table
                cellspacing="0"
                cellpadding="0"
                border="0"
                class="el-table__footer"
                style="width: 100%"
              >
                <colgroup>
                  <col name="el-table_3_column_11" width="4%" />
                  <col name="el-table_3_column_12" width="32%" />
                  <col name="el-table_3_column_13" width="10%" />
                  <col name="el-table_3_column_14" width="10%" />
                  <col name="el-table_3_column_15" width="10%" />
                  <col name="el-table_3_column_16" width="8%" />
                  <col name="el-table_3_column_17" width="8%" />
                  <col
                    name="el-table_3_column_18"
                    v-if="showHiden"
                    width="8%"
                  />
                  <col name="el-table_3_column_19" width="7%" />
                  <col name="el-table_3_column_20" width="5%" />
                </colgroup>
                <tbody class="has-gutter footer">
                  <tr>
                    <!-- <td
                      colspan="1"
                      rowspan="1"
                      class="el-table_3_column_11 is-leaf"
                    >
                      <div class="cell num">{{ ind + 1 }}</div>
                    </td> -->
                    <td
                      colspan="2"
                      rowspan="1"
                      class="el-table_3_column_12 is-leaf"
                    >
                      <div class="cell">
                        <!-- value-key="name" -->
                        <div class="searchInput">
                          <SearchProducts
                            :allStock="false"
                            :activeSide="activeSide"
                            :customer="customer"
                            ref="searchProductsComponent"
                            @selectedProduct="selectedProduct"
                            @selectedProductWithBarcode="
                              selectedProductWithBarcode
                            "
                          />
                        </div>
                      </div>
                    </td>
                    <td
                      colspan="1"
                      rowspan="1"
                      class="el-table_3_column_13 is-leaf"
                    >
                      <div class="cell">
                        <el-select
                          id="unit"
                          @input="productUnitSelected()"
                          v-model="selectedUnitId"
                          placeholder="حدد الوحدة"
                        >
                          <el-option
                            v-for="unit in productUnits"
                            :key="unit.id"
                            :label="unit.unit"
                            :value="unit.id"
                          >
                          </el-option>
                        </el-select>
                      </div>
                    </td>
                    <td
                      colspan="1"
                      rowspan="1"
                      class="el-table_3_column_14 is-leaf"
                    >
                      <div class="cell">
                        <!-- New -->

                        <vs-tooltip
                          top
                          shadow
                          not-hover
                          v-model="showQtyToolTip"
                        >
                          <input
                            :class="showQtyToolTip ? 'error' : ''"
                            class="form-control qty"
                            type="number"
                            @focus="$event.target.select()"
                            v-model="qty"
                            placeholder=" الكمية"
                            min="0"
                            @change="validateQty"
                            @keyup.enter="validateQty"
                          />
                          <template #tooltip>
                            <div class="content-tooltip">الكمية غير صحيحة</div>
                          </template>
                        </vs-tooltip>
                      </div>
                    </td>
                    <td
                      colspan="1"
                      rowspan="1"
                      class="el-table_3_column_15 is-leaf"
                    >
                      <div class="cell">
                        <vs-tooltip
                          top
                          shadow
                          not-hover
                          v-model="showPriceToolTip"
                        >
                          <input
                            type="number"
                            @change="validatePrice"
                            @keyup.enter="addNewItem"
                            :class="showPriceToolTip ? 'error' : ''"
                            v-model="sale_price"
                            @focus="$event.target.select()"
                            class="form-control sale_price"
                            placeholder=" البيع"
                            min="0"
                          />
                          <template #tooltip>
                            <div class="content-tooltip">
                              سعر البيع اقل من سعر الشراء /
                              <span
                                >سعر الشراء : {{ selectedProductBuyCost }}</span
                              >
                            </div>
                          </template>
                        </vs-tooltip>
                      </div>
                    </td>
                    <td
                      colspan="1"
                      rowspan="1"
                      class="el-table_3_column_16 is-leaf"
                    >
                      <div class="cell center">
                        {{ selectedProductlastSaleCost }}
                      </div>
                    </td>
                    <td
                      colspan="1"
                      rowspan="1"
                      class="el-table_3_column_17 is-leaf"
                    >
                      <div class="cell center" v-if="qty * sale_price > 0">
                        {{ numberToFixed(qty * sale_price) }}
                      </div>
                      <div class="cell center" v-else>-</div>
                    </td>
                    <td
                      colspan="1"
                      rowspan="1"
                      class="el-table_3_column_18 is-leaf"
                      v-if="showHiden"
                    >
                      <div class="cell center">
                        <b> {{ selectedProductBuyCost }}</b>
                      </div>
                    </td>
                    <td
                      colspan="1"
                      rowspan="1"
                      class="el-table_3_column_19 is-leaf"
                    >
                      <div class="cell center">
                        <b> {{ selectedProductStockLabel }}</b>
                      </div>
                    </td>
                    <td
                      colspan="1"
                      rowspan="1"
                      class="el-table_3_column_20 is-leaf"
                    >
                      <div class="cell center">
                        <el-button
                          v-if="product"
                          type="success"
                          @click="addNewItem"
                          title="إضافة المنتج"
                        >
                          <i class="fas fa-plus"></i>
                        </el-button>
                      </div>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </el-row>
        <el-row :gutter="10" class="footer">
          <el-col :xl="8" :lg="8" :md="18" :sm="24"
            ><div
              class="bg-White alignment px-3 mt-2"
              v-if="sales[selectedIndex].products.length > 0"
            >
              <el-row :gutter="5">
                <el-col :span="12">
                  <label for="">خصم بالقيمة</label>

                  <el-input
                    @change="discountChange"
                    @focus="$event.target.select()"
                    v-model="sales[selectedIndex].total_discount"
                    placeholder="قيمه الخصم"
                    align="middle"
                  >
                    <!-- <template slot="append">خصم</template> -->
                  </el-input>
                </el-col>
                <el-col
                  :span="12"
                  v-if="sales[selectedIndex].products.length > 0"
                >
                  <label for="">خصم بالنسبة %</label>

                  <el-input
                    @change="discountPreChange"
                    @focus="$event.target.select()"
                    v-model="sales[selectedIndex].percentage_discount"
                    placeholder="الخصم بالنسبة المئوية"
                  >
                    <!-- <template slot="append">% خصم</template> -->
                  </el-input>
                </el-col>
              </el-row>
            </div>
          </el-col>
          <el-col :xl="4" :lg="4" :md="18" :sm="24">
            <div
              class="bg-White alignment p-3 mt-2"
              v-if="sales[selectedIndex].products.length > 0"
            >
              <p>
                الكميه
                <span class="num">{{ sales[selectedIndex].total_qty }}</span>
              </p>
            </div>
          </el-col>
          <el-col :xl="12" :lg="12" :md="6" :sm="24"
            ><div class="bg-White alignment mt-2">
              <p class="px-3" v-if="sales[selectedIndex].products.length > 0">
                الفاتوره
                <span>{{
                  numberToFixed(sales[selectedIndex].total_sale_cost)
                }}</span>
              </p>
              <p class="px-3" v-if="sales[selectedIndex].total_discount > 0">
                بعد الخصم
                <span>{{
                  numberToFixed(
                    sales[selectedIndex].total_sale_cost -
                      sales[selectedIndex].total_discount
                  )
                }}</span>
              </p>
              <p class="px-3" v-if="showHiden">
                الربح
                <span>{{
                  numberToFixed(
                    sales[selectedIndex].total_sale_cost -
                      sales[selectedIndex].total_discount -
                      sales[selectedIndex].total_buy_cost
                  )
                }}</span>
              </p>
              <!-- :disabled="disabled" -->
              <el-button
                v-show="sales[selectedIndex].products.length > 0"
                class="save"
                :loading="isLoading"
                @click="showPaymentModal"
                >حفظ الفاتوره</el-button
              >

              <span
                :class="[
                  sales[selectedIndex].products.length > 0 ? '' : 'mr-auto',
                ]"
                class="pl-3"
              >
                <el-popconfirm
                  confirm-button-text="موافق"
                  cancel-button-text="إلغاء"
                  icon="el-icon-info"
                  icon-color="red"
                  title="هل تريد مسح الفاتورة؟"
                  @confirm="resetInvoiceData"
                >
                  <div slot="reference">
                    <el-button class="exit mr-3">مسح الفاتورة</el-button>
                  </div>
                </el-popconfirm></span
              >
            </div>
          </el-col>
        </el-row>
      </el-main>
      <div v-if="confirmSave == true" class="dialog">
        <div class="bodySec">
          <p @click="confirmSave = false">
            <span><i class="far fa-times-circle"></i></span> اغلاق
          </p>
        </div>
        <div class="content">
          <div class="headerSection">
            <p>الرصيد السابق</p>
            <p class="mr-auto">
              {{
                numberToFixed(
                  Number(sales[selectedIndex].customer.balance) +
                    Number(sales[selectedIndex].customer.account)
                )
              }}
            </p>
          </div>
          <div class="headerSection mt-2">
            <p>اجمالي الفاتوره</p>
            <p class="mr-auto">
              {{
                numberToFixed(
                  Number(sales[selectedIndex].total_sale_cost) -
                    Number(sales[selectedIndex].total_discount)
                )
              }}
            </p>
          </div>
          <div class="headerSection mt-2">
            <p>اجمالي المدونية</p>
            <p class="mr-auto">
              {{
                numberToFixed(
                  Number(sales[selectedIndex].total_sale_cost) -
                    Number(sales[selectedIndex].total_discount) +
                    Number(sales[selectedIndex].customer.balance)
                ) + numberToFixed(Number(sales[selectedIndex].customer.account))
              }}
            </p>
          </div>
          <div class="mt-2">
            <el-radio-group
              v-model="setPaied"
              style="justify-content: start !important"
            >
              <el-radio-button label="without">حفظ بدون تحصيل</el-radio-button>
              <el-radio-button @click="alert" label="with"
                >تحصيل</el-radio-button
              >
            </el-radio-group>
          </div>
          <div v-if="setPaied == 'with'">
            <el-row>
              <el-col> <p class="label">المبلغ المدفوع</p></el-col>
              <el-col>
                <input
                  class="form-control"
                  @focus="$event.target.select()"
                  @keyup.enter="addSale"
                  id="paied"
                  v-model="sales[selectedIndex].paied"
                />
              </el-col>
            </el-row>
          </div>
          <el-button
            class="mt-3 btn-green1 btn-save"
            type="success"
            :loading="isLoading"
            @click="addSale"
            >حفظ</el-button
          >
          <el-button
            type="danger"
            @click="confirmSave = false"
            class="exit mr-2"
            >الغاء</el-button
          >
        </div>

        <br />
      </div>
      <!-- <PrintSaleInvoice :invoice_details="invoice_details" /> -->
    </el-container>
  </div>
</template>

<script>
import Aside from "@/components/aside.vue";
import SearchCustomers from "@/components/Customers/Search";
import SearchProducts from "@/components/Products/SearchWithLastSalePrice";
// import SearchProductsWithBarcode from "@/components/Products/SearchBarcodeWithLastSalePrice";
import axiosApi from "@/plugins/axios.js";
// import { ipcRenderer } from "electron";

export default {
  components: {
    Aside,
    SearchProducts,
    SearchCustomers,
  },
  name: "Dashboard",
  data() {
    return {
      true: true,
      loadingStart: true,
      invoice_details: null,
      showHiden: false,
      disabled: false,
      isLoading: false,
      false: false,
      customer: null,
      product: null,
      selectedUnitId: null,
      productUnits: [],
      selectedUnit: null,
      sale_price: "",
      min_price: "",
      qty: 1,
      active: "sales",
      confirmSave: false,
      timeout: null,
      selectedProductlastSaleCost: "-",
      selectedProductStock: 0,
      selectedProductBuyCost: 0,
      selectedProductStockLabel: "-",
      value: "",
      num: 1,
      ind: 0,
      selectedPorductIndex: 0,
      setPaied: "without",
      activeDelete: false,
      showPriceToolTip: false,
      showQtyToolTip: false,
      selectedIndex: 0,
      showPrice: false,
      activeSide: true,
      useParcode: false,
      autoPush: true,
      sales: [
        {
          // createdAt: this.$moment().locale("en").format().substring(0, 16),
          // createdBy: JSON.parse(Cookies.get("current_user")).user.name,

          // donne_at: this.$moment().locale("en").format("YYYY-MM-DD"),
          inventory_id: JSON.parse(localStorage.getItem("user_inventories"))[0]
            .id,
          paied: 0,
          VAT: 0,
          customer: null,

          total_cost: 0,
          total_buy_cost: 0,
          total_sale_cost: 0,
          total_qty: 0,
          total_discount: 0,
          percentage_discount: 0,

          products: [],
        },
      ],
    };
  },
  watch: {
    setPaied: function () {
      this.sales[this.selectedIndex].paied = 0;
      setTimeout(() => {
        document.getElementById("paied").focus();
      }, 100);
    },

    selectedIndex: function (newValue, oldValue) {
      if (newValue != oldValue) {
        if (this.sales[newValue].customer != null) {
          this.customer = this.sales[newValue].customer;
        } else {
          this.customer = null;
        }
        this.checkOrderStock();

        this.$refs.searchCustomersComponent.setValue(this.customer);
      }
    },
  },
  created() {
    // console.log("JSON.parse(localStorage.getItem('user_inventories'))[0].id",JSON.parse(localStorage.getItem('user_inventories'))[0].id)
    if (localStorage.getItem("sales")) {
      let sale_data = localStorage.getItem("sales");

      this.sales = JSON.parse(sale_data);
      // this.checkOrderStock();
      this.customer = this.sales[this.selectedIndex].customer;

      // if (this.sales[this.selectedIndex].customer != null) {
      //   this.getCustomerAccount();
      // } else {
      //   this.customer = null;
      //   this.sales[this.selectedIndex].customer = null;
      // }
      this.calcTotal();
    }
    this.checkOrderStock();
  },
  mounted() {
    this.scrollToEnd();
  },
  methods: {
    checkOrderStock() {
      if (this.sales[this.selectedIndex].products.length > 0) {
        const loading = this.$loading({
          lock: true,
          text: "جاري تحميل الفاتورة",
          spinner: "el-icon-loading",
          background: "rgba(0, 0, 0, 0.7)",
        });
        axiosApi
          .post(`receipt/check-stock`, {
            products: this.sales[this.selectedIndex].products,
          })
          .then((res) => {
            this.sales[this.selectedIndex].products = res.data;
            this.setLocalStorage();
          })
          .catch((e) => {
            console.log(e);
            //   this.$snotify.error("عفوا لا يوجد منتج للباركود المحدد");
          })
          .finally(() => {
            loading.close();
          });
      }
    },
    validateQty() {
      // if(this.qty==0||this.qty==""){
      //   this.qty=1;
      // }
      if (
        this.qty <= this.selectedProductStock &&
        this.qty > 0 &&
        this.qty != ""
      ) {
        this.showQtyToolTip = false;
        setTimeout(() => {
          this.setPriceFocus();
        }, 200);
      } else {
        this.showQtyToolTip = true;
      }
    },
    validatePrice() {
      if (this.qty <= this.selectedProductStock) {
        if (this.sale_price > this.selectedProductBuyCost) {
          this.showPriceToolTip = false;
        } else {
          this.showPriceToolTip = true;
        }
      } else {
        this.showQtyToolTip = true;
        document.querySelector(".qty").focus();
      }
    },
    alert() {
      alert("price clicked");
    },
    openPaymentModal() {
      this.$prompt("حدد المبلغ", "تحصيل من العملاء", {
        confirmButtonText: "تحصيل",
        showClose: false,
        showCancelButton: false,
        closeOnPressEscape: false,
        closeOnClickModal: false,
        inputValue: 0,
        customClass: "float-right",
        inputErrorMessage: "مبلغ غير صحيح",
      })
        .then(({ value }) => {
          if (value >= 0) {
            this.sales[this.selectedIndex].paied = Number(value);
            this.addSale();
          } else {
            this.openPaymentModal();
            this.$notify({
              title: "حدث خطأ",
              message: "عفوا المبلغ غير صحيح ",
              type: "error",
              duration: 1500,
            });
          }
        })
        .catch(() => {
          this.sales[this.selectedIndex].paied = 0;
        });
    },
    discountPreChange() {
      this.sales[this.selectedIndex].total_discount = parseFloat(
        (this.sales[this.selectedIndex].percentage_discount *
          this.sales[this.selectedIndex].total_sale_cost) /
          100
      ).toFixed(2);
      this.setLocalStorage();
    },
    discountChange() {
      this.sales[this.selectedIndex].percentage_discount = (
        parseFloat(
          this.sales[this.selectedIndex].total_discount /
            this.sales[this.selectedIndex].total_sale_cost
        ) * 100
      ).toFixed(2);
      this.setLocalStorage();
    },
    setSelectedInvoice(index) {
      this.selectedIndex = index;
      this.customer = this.sales[index].customer;
      // if (this.sales[index].customer != null) {
      //   document.querySelector(".productQuery input").focus();
      // } else {
      //   document.querySelector(".customerQuery input").value = "";
      //   document.querySelector(".customerQuery input").focus();
      // }
      //   document.querySelector(".productQuery input").placeholder="";
      this.clearProduct();
    },
    addNewInvoice() {
      this.sales.push({
        inventory_id: JSON.parse(localStorage.getItem("user_inventories"))[0]
          .id,
        customer: null,
        paied: 0,
        VAT: 0,
        total_cost: 0,
        total_qty: 0,
        total_discount: 0,
        percentage_discount: 0,
        products: [],
      });

      // alert(this.sale.length);
      this.selectedIndex = this.sales.length - 1;
      this.$refs.searchCustomersComponent.setValue(null);
    },
    setPriceFocus() {
      if (this.showQtyToolTip == false) {
        document.querySelector(".sale_price").focus();
      }
    },
    selectedCustomer(e) {
      this.customer = e.customer;
      this.sales[this.selectedIndex].customer = e.customer;
      this.setLocalStorage();
      if (e.customer != null) {
        document.querySelector(".productQuery input").focus();
        // if (!this.useParcode) {
        // } else {
        //   document.querySelector(".parcodeSearch input[type='text']").focus();
        // }
      }
      // this.getCustomerAccount();
    },
    selectedProduct(e) {
      if (e.product != null) {
        this.product = e.product;
        this.$refs.searchProductsComponent.setValue(this.product);
        this.productUnits = e.product.prices;
        this.selectedUnitId = e.product.prices[0].id;
        this.selectedUnit = e.product.prices[0];
        if (this.sales[this.selectedIndex].customer.price_type == 1) {
          this.sale_price = this.selectedUnit.wholesale_price;
        } else {
          this.sale_price = this.selectedUnit.sale_price;
        }
        this.min_price = this.selectedUnit.min_price;
        if (this.selectedUnit.type == 1) {
          this.selectedProductBuyCost = e.product.inventories[0].pivot.buy_cost;
        } else {
          this.selectedProductBuyCost = this.numberToFixed(
            e.product.inventories[0].pivot.buy_cost /
              this.product.units_per_package
          );
        }
        this.selectedProductStock = this.numberToFixed(
          (e.product.inventories[0].pivot.qty -
            e.product.inventories[0].pivot.hold_qty) /
            this.product.units_per_package
        );
        this.selectedProductStockLabel = this.numberToFixed(
          (e.product.inventories[0].pivot.qty -
            e.product.inventories[0].pivot.hold_qty) /
            this.product.units_per_package
        );
        //    +
        // " " +
        // this.productUnits[0].unit;
        if (e.product.mainUnitLastInvoice != null) {
          this.selectedProductlastSaleCost =
            e.product.mainUnitLastInvoice.sale_price;
        } else {
          this.selectedProductlastSaleCost = "-";
        }

        //  if (e.product.prices.length > 1) {
        //           setTimeout(() => {

        //             document.getElementById('unit').focus();
        //           }, 200);

        //         } else {
        setTimeout(() => {
          document.getElementById("unit").focus();
        }, 200);
        // if (e.product.prices.length > 1) {
        // } else {
        //   this.addNewItem();
        // }
        // if (this.autoPush) {
        // } else {
        //   setTimeout(() => {
        //     document.querySelector(".qty").focus();
        //   }, 200);
        // }

        // }
      } else {
        this.clearProduct();
      }
      // this.$refs.productSearch.focus();
    },
    productUnitSelected() {
      this.selectedUnit = this.productUnits.filter((unit) => {
        return unit.id == this.selectedUnitId;
      })[0];

      if (this.sales[this.selectedIndex].customer.price_type == 1) {
        this.sale_price = this.selectedUnit.wholesale_price;
      } else {
        this.sale_price = this.selectedUnit.sale_price;
      }
      this.min_price = this.selectedUnit.min_price;

      if (this.selectedUnit.type == 1) {
        this.selectedProductBuyCost =
          this.product.inventories[0].pivot.buy_cost;
        this.selectedProductStock = this.numberToFixed(
          (this.product.inventories[0].pivot.qty -
            this.product.inventories[0].pivot.hold_qty) /
            this.product.units_per_package
        );
        this.selectedProductStockLabel = this.numberToFixed(
          (this.product.inventories[0].pivot.qty -
            this.product.inventories[0].pivot.hold_qty) /
            this.product.units_per_package
        );
      } else {
        this.selectedProductBuyCost = this.numberToFixed(
          this.product.inventories[0].pivot.buy_cost /
            this.product.units_per_package
        );

        this.selectedProductStock = this.numberToFixed(
          this.product.inventories[0].pivot.qty -
            this.product.inventories[0].pivot.hold_qty
        );
        this.selectedProductStockLabel = this.numberToFixed(
          this.product.inventories[0].pivot.qty -
            this.product.inventories[0].pivot.hold_qty
        );
      }

      //    +
      // " " +
      // this.productUnits[0].unit;
      if (this.product.mainUnitLastInvoice != null) {
        this.selectedProductlastSaleCost =
          this.product.mainUnitLastInvoice.sale_price;
      } else {
        this.selectedProductlastSaleCost = "-";
      }
      // if (this.autoPush) {
      //   this.qty = 1;
      //   this.addNewItem();
      // } else {
      //   }
      setTimeout(() => {
        document.querySelector(".qty").focus();
      }, 200);
    },
    selectedProductWithBarcode(e) {
      this.product = e.product;
      if (this.product != null) {
        this.$refs.searchProductsComponent.setValue(this.product);

        this.productUnits = e.product.prices;

        let selectedBarcodeUnit = e.product.prices.filter((item) => {
          return item.barcode == e.barcode;
        });

        this.selectedUnit = selectedBarcodeUnit[0];
        this.selectedUnitId = selectedBarcodeUnit[0].id;
        if (this.sales[this.selectedIndex].customer.price_type == 1) {
          this.sale_price = this.selectedUnit.wholesale_price;
        } else {
          this.sale_price = this.selectedUnit.sale_price;
        }
        this.min_price = this.selectedUnit.min_price;
        this.selectedProductBuyCost = e.product.inventories[0].pivot.buy_cost;
        this.selectedProductStock =
          (e.product.inventories[0].pivot.qty -
            e.product.inventories[0].pivot.hold_qty) /
          this.product.units_per_package;
        this.selectedProductStockLabel =
          (e.product.inventories[0].pivot.qty -
            e.product.inventories[0].pivot.hold_qty) /
          this.product.units_per_package;
        //    +
        // " " +
        // this.productUnits[0].unit;
        if (e.product.unitLastInvoice != null) {
          this.selectedProductlastSaleCost =
            e.product.unitLastInvoice.sale_price;
        } else {
          this.selectedProductlastSaleCost = "-";
        }
        if (this.autoPush) {
          this.addNewItem();
          // document.querySelector(".parcodeSearch input[type='text']").value = '';
        } else {
          setTimeout(() => {
            document.querySelector(".qty").focus();
          }, 200);
        }
      } else {
        this.clearProduct();
      }
    },
    showPaymentModal() {
      // ! get customer info to display balance
      this.confirmSave = true;
    },
    addNewItem() {
      if (this.loadingStart) {
        if (this.qty > 0 && !this.showQtyToolTip && !this.showPriceToolTip) {
          if (this.product && this.product.inventories.length == 0) {
            this.$snotify.error(` ${this.product.name} عفوا لا يوجد مخزون من `);
          } else {
            let barcode = this.selectedUnit.code;
            // let id = this.selectedUnit.id;
            let unit_type = this.selectedUnit.type;
            let products = [];
            // ! check qty to hold
            let selectedProduct = {
              id: this.product.id,
              qty: this.qty,
              unit_type: unit_type,
              inventory_id: JSON.parse(
                localStorage.getItem("user_inventories")
              )[0].id,
              units_per_package: this.product.units_per_package,
            };
            products.push(selectedProduct);
            const loading = this.$loading({
              lock: true,
              text: "جاري تحميل الفاتورة",
              spinner: "el-icon-loading",
              background: "rgba(0, 0, 0, 0.7)",
            });
            this.loadingStart = false;
            axiosApi
              .post(`products/hold`, { products: products })
              .then((res) => {
                loading.close();
                let available_qty = res.data.qty;
                if (unit_type == 1) {
                  available_qty = res.data.qty / this.product.units_per_package;
                }
                var product = this.sales[this.selectedIndex].products.filter(
                  function (elem) {
                    if (elem.code === barcode && elem.unit_type == unit_type)
                      return elem;
                  }
                );
                if (product.length > 0) {
                  this.sales[this.selectedIndex].products.splice(
                    this.sales[this.selectedIndex].products.findIndex(
                      (e) => e.code == barcode && e.unit_type == unit_type
                    ),
                    1
                  );
                  // if (available_qty >= this.qty) {
                  this.sales[this.selectedIndex].products.push({
                    id: product[0].id,
                    name: product[0].name,
                    barcode: product[0].barcode,
                    code: product[0].code,
                    units_per_package: product[0].units_per_package,
                    unit: product[0].unit,
                    units: product[0].units,
                    unit_type: product[0].unit_type,
                    sale_price: product[0].sale_price,
                    min_price: product[0].min_price,
                    buy_cost: Number(product[0].buy_cost),
                    stock: available_qty,
                    lastSaleCost: product[0].lastSaleCost,
                    old_qty: Number(product[0].qty) + Number(this.qty),
                    qty: Number(product[0].qty) + Number(this.qty),
                    showQtyToolTip: false, //new code
                    showPriceToolTip: false, //new code
                    inventory_id: JSON.parse(
                      localStorage.getItem("user_inventories")
                    )[0].id,
                  });
                  this.clearProduct();
                  this.calcTotal();
                  this.setLocalStorage();
                  // } else {
                  //   this.$notify.error({
                  //     title: "حدث خطأ",
                  //     message: `عفوا المخزن المتاح فقط ${available_qty} ${product[0].unit}`,
                  //     duration: 1500,
                  //   });
                  // }
                } else {
                  let buy_cost = 0;
                  // let stock = 0;
                  let lastSaleCost = "";
                  if (this.selectedUnit.type == 1) {
                    if (this.product.mainUnitLastInvoice != null) {
                      lastSaleCost =
                        this.product.mainUnitLastInvoice.sale_price;
                    }
                  } else if (this.selectedUnit.type == 2) {
                    if (this.product.secondUnitLastInvoice != null) {
                      lastSaleCost =
                        this.product.secondUnitLastInvoice.sale_price;
                    }
                  } else {
                    lastSaleCost = "";
                  }
                  if (this.product.inventories.length > 0) {
                    if (this.selectedUnit.type == 1) {
                      buy_cost = this.product.inventories[0].pivot.buy_cost;
                      // stock = Number(
                      //   available_qty / this.product.units_per_package
                      // );
                    } else {
                      buy_cost =
                        this.product.inventories[0].pivot.buy_cost /
                        this.product.units_per_package;
                      // stock = available_qty;
                    }
                  }
                  // if (stock >= this.qty) {
                  this.sales[this.selectedIndex].products.push({
                    id: this.product.id,
                    name: this.product.name,
                    code: barcode,
                    units_per_package: this.product.units_per_package,
                    unit: this.selectedUnit,
                    unit_type: this.selectedUnit.type,
                    units: this.product.prices,
                    sale_price: Number(this.sale_price),
                    min_price: this.min_price,
                    buy_cost: this.numberToFixed(buy_cost),
                    stock: available_qty,
                    lastSaleCost: lastSaleCost,
                    old_qty: Number(this.qty),
                    qty: Number(this.qty),
                    inventory_id: JSON.parse(
                      localStorage.getItem("user_inventories")
                    )[0].id,
                  });
                  this.setLocalStorage();
                  this.calcTotal();
                  this.clearProduct();
                  // } else {
                  //   console.log("there is no stock for selected product");
                  // }
                }
                this.loadingStart = true;
              })
              .catch(() => {
                this.loadingStart = true;
                loading.close();
                console.log(
                  "================ error catch for hold ==============="
                );
                this.$notify.error({
                  title: "حدث خطأ",
                  message: `عفوا المخزن المتاح لا يكفي `,
                  duration: 1500,
                });
              });
            // end hold
          }
        }
      }
      this.scrollToEnd();
    },
    addSale() {
      if (this.sales[this.selectedIndex].paied >= 0) {
        if (!this.isLoading) {
          if (this.sales[this.selectedIndex].products.length > 0) {
            this.isLoading = true;
            const loading = this.$loading({
              lock: true,
              text: "جاري تحميل الفاتورة",
              spinner: "el-icon-loading",
              background: "rgba(0, 0, 0, 0.7)",
            });
            axiosApi
              .post("sales", this.sales[this.selectedIndex])
              .then((response) => {
                console.log(response.data.invoice_details[0]);
                this.invoice_details = response.data.invoice_details[0];
                localStorage.setItem(
                  "sale_invoice",
                  JSON.stringify(response.data.invoice_details)
                );
                this.deleteSavedInvoiceData();
                this.$notify({
                  title: "تمت العملية بنجاح",
                  message: "تم حفظ بيانات الفاتورة بنجاح",
                  type: "success",
                  duration: 1500,
                });
                this.confirmSave = false;
                // window.ipcRenderer = ipcRenderer;
                // let data = {
                //   data: this.invoice_details,
                //   type: "saleInvoice",
                //   title: "مبيعات",
                //   invoiceType: "sales",
                //   img:
                //     "https://pos.staging.fatura-app.com" +
                //     JSON.parse(localStorage.getItem("branch")).logo,
                // };
                // ipcRenderer.send("printing", data);
              })
              .catch(() => {
                this.$notify.error({
                  title: "حدث خطأ",
                  message: "عفوا تأكد من بيانات الفاتورة",
                  duration: 1500,
                });
              })
              .finally(() => {
                setTimeout(loading.close(), 1000);

                this.isLoading = false;
              });
          }
        }
      } else {
        this.$notify({
          title: "حدث خطأ",
          message: "عفوا المبلغ غير صحيح ",
          type: "error",
          duration: 1500,
        });
      }
    },
    calcTotal() {
      let buy_cost = 0;
      let sale_total = 0;
      this.allowSale = true;
      var qty = 0;
      for (var i = 0; i < this.sales[this.selectedIndex].products.length; i++) {
        if (
          this.sales[this.selectedIndex].products[i].buy_cost >
          this.sales[this.selectedIndex].products[i].sale_price
        ) {
          this.allowSale = false;
          // this.$snotify.warning(
          //   " تنبيه أنت تحاول بيع" + " "+
          //     this.sales[this.selectedIndex].products[i].name +
          //     " بأقل من سعر الشراء"
          // );
        }
        if (this.sales[this.selectedIndex].products[i].qty == "") {
          this.sales[this.selectedIndex].products[i].qty = 1;
        }
        let buy = Number(
          this.sales[this.selectedIndex].products[i].qty *
            this.sales[this.selectedIndex].products[i].buy_cost
        );
        buy_cost = buy_cost + buy;
        let sale = Number(
          this.sales[this.selectedIndex].products[i].qty *
            this.sales[this.selectedIndex].products[i].sale_price
        );
        sale_total = sale_total + sale;
        qty = qty + Number(this.sales[this.selectedIndex].products[i].qty);
      }
      this.checkQty();
      this.sales[this.selectedIndex].total_buy_cost = Number(buy_cost);
      this.sales[this.selectedIndex].total_sale_cost = Number(sale_total);
      this.sales[this.selectedIndex].total_qty = Number(qty);
      this.discountChange();
      this.setLocalStorage();
    },
    checkQty() {
      for (var i = 0; i < this.sales[this.selectedIndex].products.length; i++) {
        if (Number(this.sales[this.selectedIndex].products[i].qty) == 0) {
          this.disabled = true;
          return 1;
        } else {
          this.disabled = false;
        }
        if (
          Number(this.sales[this.selectedIndex].products[i].qty) >
          Number(this.sales[this.selectedIndex].products[i].stock)
        ) {
          this.disabled = true;
          return 1;
        } else {
          this.disabled = false;
        }
        if (this.sales[this.selectedIndex].products[i].qty == "") {
          this.sales[this.selectedIndex].products[i].qty = 1;
        }
      }
    },
    setLocalStorage() {
      localStorage.setItem("sales", JSON.stringify(this.sales));
    },
    clearProduct() {
      // document.querySelector(".parcodeSearch input[type='text']").value = '';
      this.$refs.searchProductsComponent.setValue(null);
      // this.$refs.searchProductsWithBarcode.resetBarcode();
      this.qty = 1;
      this.selectedProductStock = 0;
      this.selectedProductBuyCost = "-";
      this.selectedProductStockLabel = "-";
      this.selectedProductlastSaleCost = "-";
      this.sale_price = "";
      this.product = null;
      this.selectedUnit = null;
      this.selectedUnitId = null;
      this.productUnits = [];
      //  this.$refs.productQuery.value = ''
      setTimeout(() => {
        document.querySelector(".productQuery input").focus();
        // if (!this.useParcode) {
        // } else {
        //   document.querySelector(".parcodeSearch input[type='text']").focus();
        //   document.querySelector(".parcodeSearch input[type='text']").value = '';
        // }
      }, 100);
    },
    hold(item, index) {
      let productsToHold = [
        {
          id: item.id,
          qty: item.qty,
          unit_type: item.unit_type,
          inventory_id: JSON.parse(localStorage.getItem("user_inventories"))[0]
            .id,
          units_per_package: item.units_per_package,
        },
      ];
      axiosApi
        .post(`products/hold`, { products: productsToHold })
        .then((res) => {
          this.sales[this.selectedIndex].products[index].stock =
            res.data.qty / item.units_per_package;
        });
    },
    updateProductQty(item, index) {
      if (item.old_qty != item.qty && item.qty > 0) {
        let productsToUnHold = [
          {
            id: item.id,
            old_qty: item.old_qty,
            qty: item.qty,
            unit_type: item.unit_type,
            inventory_id: JSON.parse(
              localStorage.getItem("user_inventories")
            )[0].id,
            units_per_package: item.units_per_package,
          },
        ];
        axiosApi
          .post(`product-change-qty`, {
            products: productsToUnHold,
          })
          .then((res) => {
            this.sales[this.selectedIndex].products[index].old_qty = item.qty;
            this.sales[this.selectedIndex].products[index].stock =
              res.data.qty / item.units_per_package;
          })
          .catch(() => {
            this.sales[this.selectedIndex].products[index].qty =
              this.sales[this.selectedIndex].products[index].old_qty;
            this.$notify({
              title: "عفوا",
              message: " الكمية غير متوفرة",
              type: "error",
              duration: 1500,
            });
          })
          .finally(() => {
            this.calcTotal();
          });
      } else {
        this.sales[this.selectedIndex].products[index].qty =
          this.sales[this.selectedIndex].products[index].old_qty;
        this.calcTotal();
      }
    },
    toggle(active) {
      this.activeSide = active;
    },
    resetInvoiceData() {
      // this.products = null;
      this.isLoading = true;
      const loading = this.$loading({
        lock: true,
        text: "جاري مسح الفاتورة",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.7)",
      });
      this.customer = null;
      this.$refs.searchCustomersComponent.setValue(null);
      axiosApi
        .post(`products/unhold`, {
          products: this.sales[this.selectedIndex].products,
        })
        .then(() => {
          if (this.sales.length > 1) {
            this.sales.splice(this.selectedIndex, 1);
            this.selectedIndex = 0;
          } else {
            this.sales[this.selectedIndex].products = [];
            // this.sales[this.selectedIndex].donne_at = this.$moment()
            //   .locale("en")
            //   .format("YYYY-MM-DD");
            this.sales[this.selectedIndex].customer = null;
            this.sales[this.selectedIndex].total_cost = 0;
            this.sales[this.selectedIndex].paied = 0;
            this.sales[this.selectedIndex].total_buy_cost = 0;
            this.sales[this.selectedIndex].total_sale_cost = 0;
            this.sales[this.selectedIndex].total_qty = 0;
            this.sales[this.selectedIndex].total_discount = 0;
            this.sales[this.selectedIndex].percentage_discount = 0;
            this.selectedIndex = 0;
          }
          setTimeout(() => {
            document.querySelector(".customerQuery input").value = "";
            document.querySelector(".customerQuery input").focus();
          }, 100);
          localStorage.setItem("sales", JSON.stringify(this.sales));
        })
        .finally(() => {
          setTimeout(loading.close(), 1000);

          this.isLoading = false;
        });
    },
    deleteSavedInvoiceData() {
      // this.products = null;
      this.customer = null;
      this.$refs.searchCustomersComponent.setValue(null);
      if (this.sales.length > 1) {
        this.sales.splice(this.selectedIndex, 1);
        this.selectedIndex = 0;
      } else {
        this.sales[this.selectedIndex].products = [];
        // this.sales[this.selectedIndex].donne_at = this.$moment()
        //   .locale("en")
        //   .format("YYYY-MM-DD");
        this.sales[this.selectedIndex].customer = null;
        this.sales[this.selectedIndex].total_cost = 0;
        this.sales[this.selectedIndex].paied = 0;
        this.sales[this.selectedIndex].total_buy_cost = 0;
        this.sales[this.selectedIndex].total_sale_cost = 0;
        this.sales[this.selectedIndex].total_qty = 0;
        this.sales[this.selectedIndex].total_discount = 0;
        this.sales[this.selectedIndex].percentage_discount = 0;
        this.selectedIndex = 0;
      }
      setTimeout(() => {
        document.querySelector(".customerQuery input").value = "";
        document.querySelector(".customerQuery input").focus();
      }, 100);
      localStorage.setItem("sales", JSON.stringify(this.sales));
    },
    numberToFixed(number) {
      return Math.floor(number * 100) / 100;
    },
    deleteItem(product, index) {
      // alert(index);
      this.holdProduct(product, product.unit_type, product.qty * -1);
      this.sales[this.selectedIndex].products.splice(index, 1);
      this.calcTotal();
    },
    holdProduct(product, unit_type, qty) {
      let products = [];
      let selectedProduct = {
        id: product.id,
        qty: qty,
        unit_type: unit_type,
        inventory_id: 1,
        // inventory_id: JSON.parse(Cookies.get("current_user")).inventories[0].id,
        units_per_package: product.units_per_package,
      };
      products.push(selectedProduct);
      axiosApi.post(`products/hold`, { products: products }).then((res) => {
        let available_qty = res.data.qty;
        if (unit_type == 1) {
          available_qty = res.data.qty / product.units_per_package;
        }
        return available_qty;
      });
    },
    useBarcode() {
      if (this.useParcode) {
        document.querySelector(".parcodeSearch input[type='text']").focus();
      } else {
        document.querySelector(".productQuery input").focus();
      }
    },
    scrollToEnd() {
      setTimeout(() => {
        let elementToScrollDown = this.$refs.products_table;
        elementToScrollDown.scrollTop = elementToScrollDown.scrollHeight;
      }, 300);
      // this.$el.querySelector("#goToBottom").click();
    },
    saveShortKey() {
      if (this.confirmSave) {
        this.addSale();
      }
    },
  },
};
</script>

<style scoped>
#scrollToMe {
  overflow-y: scroll;
}
</style>
